export { SearchResult } from './search-result';
